export interface FundoInvestidorParsedData {
  id: string;
  nomeFantasia: string;
  cnpjFundo: string;
  razaoSocialAdministrador: string;
  cnpjAdministrador: string;
  razaoSocialGestor: string;
  cnpjGestor: string;
  cnpjEscriturador?: string;
  cnpjCustodiante: string;
  razaoSocialBancoLiquidante: string;
  cnpjBancoLiquidante: string;
  ispbBancoLiquidante: string;
  agencia?: string;
  contaMovimento?: string;
  codigoAtivo: string;
  classe: string;
  classificacaoAnbima?: string;
  codigoAnbima?: string;
  fundoExclusivo?: string;
  tipoFundo: string;
  valido: boolean;
  mensagemErro: string;
  failedInBackend?: boolean;
  successfullyRegistered?: boolean;
}

export interface FundosInvestidoresEmLoteProps {
  fileId?: string;
  disabled?: boolean;
  inputAttachments?: Attachment[];
  onChange?(attachments: Attachment[]): void;
  onDelete?(id: string): void;
  onError?(error: any): void;
  multipleFiles?: boolean;
  aditamento?: boolean;
  overrideAcceptableFileTypes?: Array<AcceptableFileTypes>;
}

export interface Attachment {
  id: string;
  file?: File;
  remoteFileInfo?: any;
}

export enum AcceptableFileTypes {
  ImageJpeg = 'image/jpeg',
  ImagePng = 'image/png',
  AppWord = 'application/msword',
  AppWordGeneric = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  AppExcel = 'application/vnd.ms-excel',
  AppExcelGeneric = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  AppPdf = 'application/pdf',
  Txt = 'text/plain',
  Zip = 'application/zip',
  XZipCompressed = 'application/x-zip-compressed',
  Html = 'text/html',
  Email = 'message/rfc822',
  Csv = 'text/csv',
}

export const defaultAcceptableFileTypes = [
  AcceptableFileTypes.ImageJpeg,
  AcceptableFileTypes.ImagePng,
  AcceptableFileTypes.AppWord,
  AcceptableFileTypes.AppWordGeneric,
  AcceptableFileTypes.AppExcel,
  AcceptableFileTypes.AppExcelGeneric,
  AcceptableFileTypes.AppPdf,
  AcceptableFileTypes.Txt,
  AcceptableFileTypes.Zip,
  AcceptableFileTypes.XZipCompressed,
  AcceptableFileTypes.Html,
  AcceptableFileTypes.Email,
  AcceptableFileTypes.Csv,
];
